import AdditionalInfoGrid from '@/components/current-forecast/AdditionalInfoGrid';
import CurrentDate from '@/components/current-forecast/CurrentDate';
import Temperature from '@/components/current-forecast/Temperature';
import ForecastIcon from '@/components/ForecastIcon';
import HourlyScrollBar from '@/components/hourly-scroll/HourlyScrollBar';
import { CurrentForecast } from '@/models/CurrentForecast';
import { HourlyForecast } from '@/models/HourlyForecast';
import { isDarkMode } from '@/utils/CheckDarkMode';

type CurrentForecastWidgetProps = {
  currentForecast: CurrentForecast;
  hourlyForecast: HourlyForecast[];
};

const CurrentForecastWidget = ({ currentForecast, hourlyForecast }: CurrentForecastWidgetProps) => {
  const {
    description,
    icon,
    magneticField,
    precipitation,
    pressure,
    relativeHumidity,
    temperature,
    waterTemperature,
    windTemperature,
    windDegrees,
    windDirection,
    windSpeed,
    isWindSpeedAbnormal,
    isPrecipitationAbnormal,
  } = currentForecast;

  return (
    <div className="bg-blue-grey-100 py-4 dark:bg-blue-600 lg:rounded-lg lg:px-5 lg:pt-6 lg:pb-7 xl:rounded-xl xl:px-8 xl:pt-7 xl:pb-8">
      <CurrentDate />
      <div className="border-dashed border-blue-grey-500/60 lg:flex lg:items-start lg:border-b lg:pl-1 lg:pb-3 xl:pl-3">
        <div className="flex px-4 lg:px-0">
          <ForecastIcon
            iconName={icon}
            isDark={isDarkMode()}
            className="h-[90px] w-[90px] shrink-0 lg:order-last lg:h-[100px] lg:w-[100px] xl:h-[140px] xl:w-[140px]"
            alt={description}
          />
          <Temperature {...{ temperature, windTemperature, description }} />
        </div>
        <div className="mt-0.5 px-4 text-base text-grey-800 dark:text-white lg:hidden lg:px-0">{description}</div>
        <HourlyScrollBar hourlyForecast={hourlyForecast} />
      </div>
      <AdditionalInfoGrid
        {...{
          precipitation,
          relativeHumidity,
          magneticField,
          pressure,
          windDegrees,
          windSpeed,
          windDirection,
          waterTemperature,
          isWindSpeedAbnormal,
          isPrecipitationAbnormal,
        }}
      />
    </div>
  );
};

export default CurrentForecastWidget;
